import * as THREE from 'three'

const particleConfig = {
  count: 1000,
  color: "#66ff99",
  opacity: 0.3
}

const createParticles = (scene, color = "#66ff99") => {
  const particlesGeometry = new THREE.BufferGeometry()

  const positions = new Float32Array(particleConfig.count * 3)
  const initialPositions = new Float32Array(particleConfig.count * 3)
  const colors = new Float32Array(particleConfig.count * 3)
  const speeds = new Float32Array(particleConfig.count)
  const maxDistances = new Float32Array(particleConfig.count)

  for (let i = 0; i < particleConfig.count; i++) {
    const i3 = i * 3
    const angle = Math.random() * Math.PI * 2
    initialPositions[i3] = positions[i3] = Math.sin(angle) * Math.random() * 6
    initialPositions[i3 + 1] = positions[i3 + 1] = (Math.random()) * 10
    initialPositions[i3 + 2] = positions[i3 + 2] = Math.cos(angle) * Math.random() * 6

    maxDistances[i] = Math.random() * 3 + positions[i3 + 1]
    speeds[i] = Math.random() * 0.01

    colors[i3] = Math.random()
    colors[i3 + 1] = Math.random()
    colors[i3 + 2] = Math.random()
  }

  particlesGeometry.setAttribute(
    'position',
    new THREE.BufferAttribute(positions, 3)
  )

  particlesGeometry.setAttribute(
    'initialPosition',
    new THREE.BufferAttribute(initialPositions, 3)
  )

  particlesGeometry.setAttribute(
    'speed',
    new THREE.BufferAttribute(speeds, 1)
  )

  particlesGeometry.setAttribute(
    'maxDistance',
    new THREE.BufferAttribute(maxDistances, 1)
  )

  particlesGeometry.setAttribute(
    'color',
    new THREE.BufferAttribute(colors, 3)
  )

  //Material
  const particlesMaterial = new THREE.PointsMaterial({
    size: 0.2,
    sizeAttenuation: true,
    depthWrite: true,
    color: color,
    transparent: true,
    opacity: particleConfig.opacity
    //vertexColors: true
  })

  //Points
  const particles = new THREE.Points(particlesGeometry, particlesMaterial)
  scene.add(particles)

  return particles
}

const updateParticles = (particles) => {
  const particlesGeometry = particles.geometry
  if (particlesGeometry !== null){
    for (let i =0; i < particleConfig.count; i++) {
      const i3 = i * 3
      if (particlesGeometry.attributes.position.array[i3 + 1] > particlesGeometry.attributes.maxDistance.array[i]) {
        particlesGeometry.attributes.position.array[i3 + 1] = particlesGeometry.attributes.initialPosition.array[i3 + 1]
      } else {
        particlesGeometry.attributes.position.array[i3 + 1] += particlesGeometry.attributes.speed.array[i]
      }
    }

    particlesGeometry.attributes.position.needsUpdate = true
  }
}

export {
  particleConfig,
  createParticles,
  updateParticles
}